<div class="d-flex align-items-center">
  <h3>{{ dialogTitle }}</h3>
  <ng-content></ng-content>
</div>
<button mat-icon-button mat-dialog-close>
  <mat-icon svgIcon="close"></mat-icon>
</button>